import { Model } from 'components/discovery/utils/model.js'

export type GeocodeGeometry = {
  location: {
    lat: number,
    lng: number,
  },
  location_type: string,
}

type GeocodesResults = Array<{
  formatted_address: string,
  geometry: GeocodeGeometry,
  place_id: string
}>

export type Geocodes = {
  results: GeocodesResults,
  status: string,
}

export class GeocodesModel extends Model<Geocodes> implements Geocodes {
  results: GeocodesResults = []
  status = ''
}
